import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getPAOccupationSlice = createSlice({
  name: "getPAOccupation",
  initialState,
  reducers: {
    getPAOccupationStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getPAOccupationSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getPAOccupationFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getPAOccupationStart,
  getPAOccupationSuccess,
  getPAOccupationFailure,
  clearError,
  clearMessage,
} = getPAOccupationSlice.actions;

export default getPAOccupationSlice.reducer;
